import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CLOUDS } from '../data/catalog';

const KEYS = Object.keys(CLOUDS);

const CloudExpertise = () => {
  const [active, setActive] = useState('azure');
  const cloud = CLOUDS[active];

  return (
    <section className="band band-dark" id="cloud">
      <div className="wrap">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow-dark">Cloud Platform Expertise</span>
          <h2>Multi-cloud depth, Azure-led</h2>
          <p>
            Certified and delivery-proven across all three hyperscalers, with Azure as the primary
            platform of record for the majority of engagements.
          </p>
        </motion.div>

        <div className="cloud-tabs">
          {KEYS.map((k) => (
            <button
              key={k}
              className={`cloud-tab-btn ${active === k ? 'active' : ''}`}
              onClick={() => setActive(k)}
            >
              {CLOUDS[k].label}
            </button>
          ))}
        </div>

        <motion.div key={active} className="cloud-panel" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
          <div className="cloud-services">
            <h4>Core {cloud.label} Services</h4>
            <ul>
              {cloud.services.map((s) => <li key={s}>{s}</li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CloudExpertise;
